import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { get } from '@elliemae/ds-utilities/utils';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isVisible = function isVisible(column) {
  if (typeof column === 'undefined') {
    return false;
  }

  return typeof column.visible === 'undefined' || column.visible;
};

var getColumnValue = function getColumnValue(row, property) {
  return get(row, property);
};
var getVisibleRowData = function getVisibleRowData(row, columns) {
  return columns.reduce(function (result, column) {
    var columnProperty = column.property;
    return isVisible(column) ? [].concat(_toConsumableArray(result), [getColumnValue(row, "_".concat(columnProperty)) || getColumnValue(row, columnProperty)]) : result;
  }, []);
};

var defaultOptions = function defaultOptions(uuid) {
  return {
    sheetName: 'SheetName',
    fileName: "datagrid-".concat(uuid),
    type: 'csv',
    onlySelection: false,
    excludedColumns: undefined
  };
};

var getOptions = function getOptions(opts, uuid) {
  return _objectSpread(_objectSpread({}, defaultOptions(uuid)), opts);
};

var getCellValue = function getCellValue(cell) {
  if (cell === undefined || cell === null) return '';
  return cell;
};

var getExportedData = function getExportedData(rows, columns, range) {
  var rowsRanged = range ? rows.slice.apply(rows, _toConsumableArray(range)) : rows;
  var dataToExport = rowsRanged.map(function (row) {
    return getVisibleRowData(row, columns);
  });
  var columnsContent = columns.filter(function (c) {
    return isVisible(c);
  }).reduce(function (acc, curr, idx) {
    return "".concat(acc).concat(idx === 0 ? '' : ',').concat(curr.label);
  }, '');
  var rowsContent = dataToExport.map(function (e) {
    return e.map(function (r) {
      return "\"".concat(String(getCellValue(r)).replace(/"/g, '""'), "\"");
    }).join(',');
  }).join('\r\n');
  var csvContent = "".concat(columnsContent, "\r\n").concat(rowsContent);
  return csvContent;
}; // eslint-disable-next-line max-statements

var exportTo = function exportTo(rows, columns, _ref) {
  var range = _ref.range,
      fileName = _ref.fileName,
      type = _ref.type,
      excludedColumns = _ref.excludedColumns;

  if (excludedColumns) {
    // eslint-disable-next-line no-param-reassign
    columns = columns.filter(function (col) {
      return !excludedColumns.includes(col.property);
    });
  }

  var csvContent = getExportedData(rows, columns, range);
  var blob = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8;'
  });

  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, "".concat(fileName, ".").concat(type));
  } else {
    var link = document.createElement('a');

    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', "".concat(fileName, ".").concat(type));
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

var ExportDataPlugin = createInstancePlugin('export-data', {
  decorateGrid: function decorateGrid(instance) {
    return {
      exportRows: function exportRows() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var _instance$getInstance = instance.getInstance(),
            rows = _instance$getInstance.composedRows,
            columns = _instance$getInstance.columns,
            uuid = _instance$getInstance.uuid,
            rowKey = _instance$getInstance.props.rowKey,
            selection = _instance$getInstance.state.selection;

        var options = getOptions(opts, uuid); // check paginated rows

        var currentRows = rows.allRows || rows;

        if (opts.onlySelection) {
          var selectedRows = Object.keys(selection.selectedRows);
          currentRows = currentRows.filter(function (r) {
            return selectedRows.includes(String(r[rowKey]));
          });
        }

        exportTo(currentRows, columns, options);
      },
      exportVisibleRows: function exportVisibleRows() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var _instance$getInstance2 = instance.getInstance(),
            rows = _instance$getInstance2.composedRows,
            columns = _instance$getInstance2.columns,
            uuid = _instance$getInstance2.uuid,
            rowKey = _instance$getInstance2.props.rowKey,
            selection = _instance$getInstance2.state.selection;

        var options = getOptions(opts, uuid); // check paginated rows

        var currentRows = rows.rows || rows;

        if (opts.onlySelection) {
          var selectedRows = Object.keys(selection.selectedRows);
          currentRows = currentRows.filter(function (r) {
            return selectedRows.includes(String(r[rowKey]));
          });
        }

        exportTo(currentRows, columns, options);
      }
    };
  }
});

export { ExportDataPlugin, getColumnValue, getExportedData, getVisibleRowData };
//# sourceMappingURL=ExportDataPlugin.js.map
